import CryptoJS from "crypto-js";

const secretKey = "64689-darkeb";

// تابع برای رمزگذاری داده‌ها
function encryptData(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
}

// تابع برای ذخیره داده‌ها در localStorage
function saveData(key, data) {
  const encryptedData = encryptData(data);
  localStorage.setItem(key, encryptedData);
}

// تابع برای رمزگشایی داده‌ها
function decryptData(encryptedData) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("خطا در رمزگشایی داده‌ها:", error);
    return null;
  }
}

// تابع برای دریافت داده‌ها از localStorage
function getData(key) {
  const encryptedData = localStorage.getItem(key);
  if (encryptedData) {
    return decryptData(encryptedData);
  }
  return null;
}

export default {
  encryptData,
  saveData,
  getData,
  secretKey,
};
